module.exports = __webpack_public_path__ + "img/risorse_in_prova_emt.57cb2b90.png";